import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import {
  AlarmClockCheck,
  ArrowDownRight,
  ArrowUpRight,
  Calendar,
  Calendar1,
  CalendarDays,
  CheckCircle2,
  CircleDollarSign,
  Clock,
  Eye,
  FileDown,
  FileText,
  FolderTree,
  IdCard,
  KanbanIcon,
  ListIcon,
  Mail,
  Pencil,
  PlusIcon,
  ShieldX,
  Tag,
  User,
} from "lucide-react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { motion } from "framer-motion";
import DynamicFilter from "../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../component/table/customize-table";
import LayoutTopIcon from "../../../component/icons/layout-top";
import XCloseIcon from "../../../component/icons/x-close";
import { CustomDropdown } from "../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../component/ui/dropdown/CustomDropdownMenuList";
import Tooltip from "../../../component/ui/tooltip";
import FileCode1Icon from "../../../component/icons/file-code-1";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFooter,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import ChevronDownIcon from "../../../component/icons/chevron-down";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { useParams } from "react-router";
import AddWalletTransaction from "./add-wallet-transaction/add-wallet-transaction";
import DashboardKPI from "../../../component/dashboard-kpi/DashboardKPI";

// function KPI({ icon: Icon, label, value, sublabel, positive, stateLabel }) {
//   return (
//     <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-xl transition-all cursor-pointer">
//       <div className="flex items-center gap-3">
//         <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-blue-500 to-indigo-500 text-white">
//           <Icon className="w-6 h-6" />
//         </div>
//         <div>
//           <p className="text-sm text-gray-500 font-medium">{label}</p>
//           <h3 className="text-lg md:text-xl font-semibold mt-1">{value}</h3>
//         </div>
//       </div>

//       {positive != null && (
//         <span
//           className={`mt-3 inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${positive
//             ? "bg-green-100 text-green-700"
//             : "bg-red-100 text-red-700"
//             }`}
//         >
//           {positive ? <ArrowUpRight className="w-3 h-3 mr-1" /> : <ArrowDownRight className="w-3 h-3 mr-1" />}
//           {stateLabel}
//         </span>
//       )}

//       {sublabel && <p className="mt-2 text-xs text-gray-400">{sublabel}</p>}
//     </div>
//   );
// }


const Wallet = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeader, setTableHeader] = useState([]);
  const [wallet, setWallet] = useState({});
  const [tableFooter, setTableFooter] = useState([]);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const [exportTo, setExportTo] = useState(false);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedDeals, setSelectedDeals] = useState([]);
  const [addTransactionModal, setAddTransactionModal] = useState(false);

  const { id } = useParams();

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedProjects(apiData.map((d) => d.projectkey));
    } else {
      setSelectedProjects([]);
    }
  };

  // ✅ Toggle Single Row
  const toggleSelectRow = (projectKey) => {
    setSelectedProjects((prev) =>
      prev.includes(projectKey)
        ? prev.filter((id) => id !== projectKey)
        : [...prev, projectKey]
    );
  };

  const handleExport = async (type, localData = null) => {
    try {
      // ✅ If user already selected rows (local data)
      if (localData && localData.length > 0) {
        exportWalletData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Wallets...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // 🧩 Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      // 🧠 Call API
      const res = await apiCall({
        url: `wallet/wallet-transactions-list`, // 👈 Update this to your wallet endpoint
        method: "post",
        data: apiData,
      });

      const walletData = res?.data || res?.wallets || [];
      if (!walletData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No wallet data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportWalletData(walletData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting wallets.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportWalletData = (data, type) => {
    if (!data || !data.length) return;

    const columnOrder = ["timestamp", "reason", "debit", "credit", "balance_after_formatted", "agent_name"];

    // Always include timestamp as first column
    const visibleColumns = [
      { key: "timestamp", value: "Date" }, // force timestamp first
      ...tableHeader
        ?.filter((col) => col.is_visible === 1 && col.show === 1 && col.key !== "timestamp")
        ?.sort((a, b) => columnOrder.indexOf(a.key) - columnOrder.indexOf(b.key))
    ];

    // Map data rows
    const formattedData = data.map((row) => {
      const obj = {};
      visibleColumns.forEach(({ key, value }) => {
        obj[value] = row[key] ?? "-";
      });
      return obj;
    });

    // Add Closing Balance row
    const lastRow = data[data.length - 1];
    const closingRow = {};
    visibleColumns.forEach(({ key, value }) => {
      if (key === "timestamp") {
        closingRow[value] = lastRow[key] ?? "-";
      } else if (key === "reason") {
        closingRow[value] = "Closing Balance";
      } else if (key === "balance_after_formatted") {
        closingRow[value] = lastRow[key] ?? "-";
      } else {
        closingRow[value] = "--";
      }
    });
    formattedData.push(closingRow);

    // File name
    const fileName = `wallets_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}`;

    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Wallets");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Wallet data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setAddTransactionModal(false)
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `wallet/wallet-transactions-list/${id}${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => {
          const newData = { ...prev };
          for (const [date, txns] of Object.entries(res.data || {})) {
            if (!newData[date]) newData[date] = [];
            newData[date] = [...newData[date], ...txns];
          }
          return newData;
        });
      } else {
        setApiData(res.data || {});
        setWallet(res?.wallet);
      }

      setTableHeader(res?.applied_headers);
      setTableFooter(res?.footer);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "type",
      label: "Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "debit", value: "debit" },
        { label: "credit", value: "Credit" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
    {
      name: "amount",
      label: "Amount",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "number",
    },
    {
      name: "balance",
      label: "Balance",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "number",
    },
    {
      name: "reason",
      label: "Reason",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
    {
      name: "agent",
      label: "Agent",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "number",
    },
    {
      name: "date",
      label: "Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* Top Cards */}
              {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                {!isLoading ? (
                  <>
                    <KPI
                      icon={User}
                      label="Owner Name"
                      
                      value={wallet?.customer_name}
                   
                    />
                    <KPI
                      icon={Mail}
                      label="Owner Email"
                      value={wallet?.email}
                    
                    />
                    <KPI
                      icon={CircleDollarSign}
                      label="Current Balance"
                      value={wallet?.balance}
                   
                    />
                    <KPI
                      icon={Clock}
                      label="Created At"
                      value={wallet?.created}
                   
                    />
                    <KPI
                      icon={AlarmClockCheck}
                      label="Last Update"
                      value={wallet?.last_updated}
                    
                    />
                  </>
                ) : (
                  Array.from({ length: 5 }).map((_, index) => (
                    <div
                      key={index}
                      className="bg-white shadow rounded-xl p-4 animate-pulse"
                    >
                    
                      <div className="flex items-center justify-between mb-2">
                        <Skeleton variant="text" width={80} height={16} />
                        <Skeleton variant="circular" width={20} height={20} />
                      </div>
                     
                      <div className="flex items-center justify-between gap-2 mb-1">
                        <Skeleton variant="text" width={60} height={32} />
                        <Skeleton variant="rounded" width={40} height={20} />
                      </div>
                      
                      <Skeleton variant="text" width={80} height={12} />
                    </div>
                  ))
                )}
              </div> */}

              <DashboardKPI wallet={wallet} />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>

                  {/* Title */}
                  <div className="flex items-center gap-3 mb-4">
                    {/* <div className="p-2 rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500 text-white">
                      <FileText className="w-5 h-5" />
                    </div> */}
                    <h3 className="text-xl md:text-2xl font-semibold text-gray-800 tracking-tight">
                      Transaction Statement
                    </h3>
                  </div>

                  {/* filter div */}
                  {filterReturn?.length ? (
                    <div className={Style.filterContainer}>
                      <p className={Style.searchText}>Search By</p>
                      {filterReturn?.map((eachFilter, i) => {
                        return (
                          <div className={Style.eachFilter} key={i}>
                            <p
                              onClick={() => {
                                setShowModalFilterTable(true);
                              }}
                            >
                              <span>
                                {eachFilter?.name
                                  ?.replace("search_by_", "")
                                  .replaceAll("_", " ")}{" "}
                                :{" "}
                              </span>
                              <b>{eachFilter?.selectedOperator}</b>
                              <em>
                                {typeof eachFilter?.value == "string"
                                  ? eachFilter?.value
                                  : eachFilter?.value?.map((eachVal, index) => {
                                    return `${eachVal} ${eachFilter?.value?.length - 1 != index
                                      ? "& "
                                      : ""
                                      }`;
                                  })}
                              </em>
                            </p>

                            <span
                              className={Style.searchClosedBtn}
                              onClick={() => {
                                removeFilter(i);
                              }}
                            >
                              <div className={Style.icon}>
                                <XCloseIcon />
                              </div>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : null}



                </div>
                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setAddTransactionModal(true);
                        // setTransactionData()
                      }}
                    >
                      <Tooltip
                        content={"Add Transaction"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>


                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    {/* <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip> */}

                    <CustomDropdown
                      position="bottom-right"
                      className={`myDropdown`}
                    >
                      <CustomDropdownButton arrow={false} className="btnClass">
                        <DotsVerticalIcon />
                      </CustomDropdownButton>

                      <CustomDropdownMenu>
                        <CustomDropdownMenuList
                          className={Style.CustomDropdownMenuList}
                          closed={false}
                        >
                          <div
                            className={Style.CustomDropdownMenuListBtn}
                            onClick={() => setExportTo(!exportTo)}
                          >
                            <div className="">
                              <LayoutTopIcon /> Export to
                            </div>
                            <div
                              className={`${Style.dropArrow} ${exportTo ? Style.isActive : null
                                }`}
                            >
                              <ChevronDownIcon />
                            </div>
                          </div>

                          {exportTo ? (
                            <div className={Style.subItemMenu}>
                              <CustomDropdownMenuList
                                className={Style.subItemList}
                                onClick={() => {
                                  const dataToExport =
                                    selectedProjects.length > 0
                                      ? apiData.filter((d) =>
                                        selectedProjects.includes(d.id)
                                      )
                                      : apiData;

                                  // ✅ Call the new unified export function
                                  const flatData = Object.values(apiData).flat();
                                  handleExport("csv", flatData);
                                }}
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <FileCode1Icon /> CSV
                                </div>
                              </CustomDropdownMenuList>

                              <CustomDropdownMenuList
                                className={Style.subItemList}
                                onClick={() => {
                                  const dataToExport =
                                    selectedProjects.length > 0
                                      ? apiData.filter((d) =>
                                        selectedProjects.includes(d.id)
                                      )
                                      : apiData;

                                  // ✅ Call the new unified export function
                                  const flatData = Object.values(apiData).flat();
                                  handleExport("excel", flatData);
                                }}
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <FileCode1Icon /> XLSX
                                </div>
                              </CustomDropdownMenuList>
                            </div>
                          ) : null}
                        </CustomDropdownMenuList>
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : Object.keys(apiData || {}).length === 0 ? (
                  <DataNotFound title={"Wallets"} />
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        {(() => {
                          const columnOrder = ["timestamp", "reason", "debit", "credit", "balance_after_formatted", "agent_name"];

                          const sortedTableHeader = tableHeader
                            ?.filter(h => h.is_visible === 1 && h.show === 1)
                            .sort((a, b) => columnOrder.indexOf(a.key) - columnOrder.indexOf(b.key));

                          return (
                            <>
                              {/* TABLE HEAD */}
                              <TableHead>
                                <TableRow>
                                  <TableCell header sticky>
                                    <TableHeaderWrap>Date</TableHeaderWrap>
                                  </TableCell>

                                  {sortedTableHeader.map((eachHead, index) => (
                                    <TableCell header key={index}>
                                      <TableHeaderWrap>
                                        <span>{eachHead?.value}</span>
                                      </TableHeaderWrap>
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>

                              {/* TABLE BODY */}
                              <TableBody>
                                {Object.entries(apiData || {}).map(([date, transactions], groupIndex) => (
                                  <React.Fragment key={groupIndex}>
                                  
                                    <TableRow className="bg-gray-100 !font-bold text-center">
                                      <TableCell colSpan={sortedTableHeader.length + 1}>
                                        <div className="flex justify-center items-center gap-1">
                                          <CalendarDays className="w-4 h-4" />
                                          {date}
                                        </div>

                                      </TableCell>
                                    </TableRow>

                                    {/* 🔹 Transactions */}
                                    {transactions.map((txn, rowIndex) => (
                                      <TableRow key={`${groupIndex}-${rowIndex}`}>
                                        <TableCell sticky>{txn.timestamp ?? "-"}</TableCell>
                                        {sortedTableHeader.map((col, colIndex) => (
                                          <TableCell
                                            key={colIndex}
                                            className={
                                              col.key === "credit"
                                                ? "!text-green-600 font-semibold"
                                                : col.key === "debit"
                                                  ? "!text-red-600 font-semibold"
                                                  : ""
                                            }
                                          >
                                            {txn[col.key] ?? "-"}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    ))}
                                  </React.Fragment>
                                ))}



                                {/* 🔹 Closing Balance Row */}
                                <TableRow className="font-bold">
                                  {/* First column: last transaction date */}
                                  <TableCell sticky>
                                    {(() => {
                                      // Get the last date group
                                      const lastDate = Object.keys(apiData || {}).pop();
                                      const lastGroup = lastDate ? apiData[lastDate] : [];
                                      const lastTxn = lastGroup?.[lastGroup.length - 1];

                                      return lastTxn?.timestamp ?? "--";
                                    })()}
                                  </TableCell>

                                  {/* Remaining columns */}
                                  {sortedTableHeader.map((h_ele, colIndex) => {
                                    const lastDate = Object.keys(apiData || {}).pop();
                                    const lastGroup = lastDate ? apiData[lastDate] : [];
                                    const lastTxn = lastGroup?.[lastGroup.length - 1];

                                    return (
                                      <TableCell
                                        key={`cb-${colIndex}`}
                                        className={
                                          h_ele.key === "balance_after_formatted"
                                            ? "font-number !font-bold"
                                            : h_ele.key === "reason"
                                              ? "!font-bold text-gray-700"
                                              : ""
                                        }
                                      >
                                        {h_ele.key === "balance_after_formatted"
                                          ? lastTxn?.[h_ele.key] ?? "--"
                                          : h_ele.key === "reason"
                                            ? "Closing Balance"
                                            : "--"}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>

                              </TableBody>


                              {/* TABLE FOOTER */}
                              <TableFooter>
                                <TableRow>
                                  <TableCell
                                    sticky
                                    header
                                    className="text-gray-800 font-bold tracking-wide uppercase"
                                  >
                                    Summary
                                  </TableCell>

                                  {sortedTableHeader.map((h_ele, h_idx) => (
                                    <TableCell
                                      header
                                      key={`tf-${h_idx}`}
                                      className={`${h_ele?.type === "number" ? "!text-end font-number" : ""
                                        } ${h_ele?.key === "credit"
                                          ? "!text-green-600 font-semibold"
                                          : h_ele?.key === "debit"
                                            ? "!text-red-600 font-semibold"
                                            : ""
                                        }`}
                                    >
                                      {tableFooter[h_ele?.key] ?? "--"}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableFooter>
                            </>
                          );
                        })()}
                      </Table>

                    </TableCard>


                  </>
                )}
              </div>

              {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  {`showing 1 to ${Object.values(apiData || {}).reduce((sum, group) => sum + group.length, 0)
                    } of ${tablePagination?.total || Object.values(apiData || {}).reduce((sum, group) => sum + group.length, 0)}`}


                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            // setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            // filterData({ page: pageCount + 1, btnCall: true });
                            getData({
                              page: tablePagination?.current_page + 1,
                            });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div >
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="wallet-transactions-list"
        />
      )
      }

      {
        showModalCustomizeTabs && (
          <CustomizeTabsPopup
            data={tableHeader}
            onClose={() => {
              setShowModalCustomizeTabs(false);
              const table = tableRef?.current;
              if (table) {
                table.style.zIndex = 1;
              }
            }}
            onPreview={(updatedHeaders) => {
              setTableHeader(updatedHeaders);
              const table = tableRef?.current;
              table.style.zIndex = 100;
            }}
            onPreviewClose={() => {
              const table = tableRef?.current;
              table.style.zIndex = 1;
            }}
            onSave={(saveHeaders) => {
              setTableHeader(saveHeaders);
              const table = tableRef?.current;
              if (table) {
                table.style.zIndex = 1;
              }
            }}
            apiUrl="wallet-transactions-list"
          />
        )
      }

      {
        addTransactionModal && (
          <AddWalletTransaction
            onClose={() => {
              setAddTransactionModal(false);
            }}
            onError={onError}
            onSubmit={onSuccess}
            walletId={wallet?.id}
            currentBalance={wallet?.back_balance}
          />
        )
      }

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Wallet;
